module.exports = __webpack_public_path__ + "static/media/neutral-feedback.0936ac23.png";